import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { toFormData } from '@platform/shared/utilities/file-utility';
import { MobileUploadDto } from './mobile-upload.model';

@Injectable({
  providedIn: 'root',
})
export class MobileUploadService {
  constructor(private http: HttpClient) {}

  public getMobileUpload(customerSpaceId: string, mobileUploadId: string): Observable<MobileUploadDto> {
    return this.http.get<MobileUploadDto>(`${environment.apiUrl}/customer-spaces/${customerSpaceId}/mobile-upload/${mobileUploadId}`);
  }

  public uploadFiles(customerSpaceId: string, mobileUploadId: string, files: FileList | File[]): Observable<void> {
    const formData = toFormData(files);

    return this.http.post<void>(`${environment.apiUrl}/customer-spaces/${customerSpaceId}/mobile-upload/${mobileUploadId}/files`, formData);
  }
}
